<template>
    <v-card class="expense-card">
        <v-snackbar :color="color" :timeout="callbackResponse.timeout" top v-model="snackbar.snackbar">
            {{ callbackResponse.message }}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <div class="sticky-toolbar">
            <v-toolbar class="toolbar" color="indigo" dark>
                <v-toolbar-title>
                    View
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="dialogueClose" dark icon>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </div>
        <v-container>
            <v-row>
                <v-col md="3">
                    <v-select v-model="expenses.fiscalYearID" dense outlined
                              :items="fiscalYearList"
                              @change="approvalallBudgetYearList"
                              item-text="id"
                              item-value="value">
                        <template v-slot:label>
                            {{ $t("fiscal_year") }}
                        </template>
                    </v-select>
                </v-col>
                <v-col md="3">
                    <v-autocomplete v-model="expenses.monthID"
                                    required
                                    dense
                                    outlined
                                    :items="monthList"
                                    label="Select Month"
                                    clearable
                                    single-line
                                    item-text="id"
                                    item-value="value"></v-autocomplete>
                </v-col>
                <v-col md="3">
                    <v-autocomplete v-model="expenses.reportID"
                                    required
                                    dense
                                    outlined
                                    :items="listDatas"
                                    label="Select Report"
                                    clearable
                                    single-line
                                    item-text="value"
                                    item-value="id"></v-autocomplete>
                </v-col>
                <v-col md="3">
                    <v-btn color="primary ml-4" @click="loadItems">{{$t('search')}}</v-btn>
                </v-col>
            </v-row>
            <vue-good-table mode="remote"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            :totalRows="totalRecords"
                            :isLoading.sync="isLoading"
                            :pagination-options="{ enabled: false, }"
                            :rows="firstrows"
                            :columns="columns">

            </vue-good-table>
        </v-container>
    </v-card>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import axios from "axios";

    export default {
        name: 'AddComponent',
        watch: {
            "logData": {
                handler: async function () {
                    this.$emit("logDataResponse", this.logData)
                },
                deep: true
            },
        },
        computed: {
            isCompany() {
                let check = this.role == "SuperAdmin"
                return check
            },
            isDepartment() {
                let check = this.role == "Company" || this.role == "SuperAdmin"
                return check
            },
            isBranch() {
                let check = this.role == "Company" || this.role == "SuperAdmin" || this.tokenData.role == "Department"
                return check
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                    errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                    errors.push("Year is required.");
                return errors;
            },
        },
        props: ['viewData'],
        components: {},
        data() {
            return {
                panelData: [0, 1],
                selectedStatus: {
                    company: "",
                    branch: ""
                },
                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                status: {
                    isCompany: false,
                    isDepartment: false,
                },
                expenses: {
                    reportID: 0,
                    fiscalYearID: 0,
                    monthID: 0
                },
                columns: [
                    {
                        label: "Report Name",
                        field: "reportName"
                    },
                    {
                        label: "Subsection Name",
                        field: "subSectionName"
                    },
                    {
                        label: "Expenses Amount",
                        field: "expensesAmount"
                    }
                ],
                table: false,
                isLoading: false,
                dialogCreate: false,
                monthList: [],
                subsectionList: [],
                breadCrumbs: [],
                IsActive: false,
                TotalHeaderIndex: 0,
                rows: [],
                listDatas: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                firstrows: [],
                totalRecords: 0,
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                reportList: [],
                reportLogs: [],
                subColumns: [],
                fiscalYearList: [],
                yearList: [],
                tableFormData: [],
                snackbar: {
                    snackbar: false,
                    dateMenu: false,
                    servicesData: {
                        data: {},
                        message: "",
                        color: ""
                    },
                },
                helpData: [],
                radioColors: ['#47bf88de', '#FF5733', '#3A89F1', '#9C27B0'],
                logData: this.$route.query,
                serverData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "reportID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                workStatusList: [],
                color: "",
                validAmount: 0,
                isvalidtoexpense: false,
                validMsg: ""
            };
        },
        validations: {
            logData: {
                companyID: { required },
                year: { required },
            }
        },

        methods: {
            dialogueClose() {
                this.expenses = {
                    monthID: 0,
                    reportID: 0,
                    fiscalYearID: 0,
                }
                this.isvalidtoexpense = false;
                this.validMsg = "";
                this.validAmount = 0;
                this.$emit("formResponse", this.servicesData);
            },
            
            onResponse(data) {
                console.log("yets" + data);
                if (data == true) {
                    this.dialogCreate = false;
                    this.dialogEdit = false;
                    this.dialogRow = false;
                    this.loadItems();
                }
            },
            onFormResponse() {
                this.dialogRow = false;
                this.dialogView = false;
                this.dialogViewAll = false;
            },
            scrollToTargetDiv() {
                if (this.$refs.targetDiv) {
                    this.$refs.targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            },
            searchInput() {
                this.loadItems();
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },


            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({ perPage: params.currentPerPage });
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [
                        {
                            type: params[0].type,
                            field: params[0].field
                        }
                    ]
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            apiData() {
                axios.get('ReportSettings/GetReportYearList').then(response => {
                    this.fiscalYearList = response.data
                })
                axios.get('ReportSettings/GetYearMonthsList').then(response => {
                    this.monthList = response.data
                })
                this.approvalallBudgetYearList()
            },
            approvalallBudgetYearList() {
                let param = {
                    companyID: 0,
                    branchID: null,
                    depoID: null,
                    fiscalYearID: parseInt(this.expenses.fiscalYearID),
                }
                axios.post("ReportSettings/ApprovalallBudgetYearList", param).then(response => {
                    this.listDatas = response.data
                })
            },
            currentFiscalYear() {
                axios.get("ReportSettings/GetCurrentFiscalYear").then(response => {
                    this.expenses.fiscalYearID = response.data.value
                    this.apiData()
                })
            },
            async loadItems() {
                let param = {
                    fiscalYearID: parseInt(this.expenses.fiscalYearID),
                    monthID: parseInt(this.expenses.monthID == null ? 0 : this.expenses.monthID),
                    ReportID: parseInt(this.expenses.reportID == null ? 0 : this.expenses.reportID),
                    companyID: 0,
                    branchID: null,
                    depoID: null,
                    officeType: '',
                };
                try {
                    const response = await axios.post("ReportSettings/GetAllBudgetAndExpensesReportAsync", param);
                    this.firstrows = response.data;
                    this.totalRecords = response.data.totalCount;
                } catch (e) {
                    if (e.response.data.State == "AccessTokenExpired") {
                        this.apiResponse(e);
                        this.loadItems();
                    }
                }
                return;
            },

        }
    };
</script>

<style scoped>
    .expense-card {
        padding: 20px;
        background-color: #f5f5f5;
        border-radius: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .toolbar {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }

    .actions {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        background-color: #e0e0e0;
        padding: 10px;
        display: flex;
        justify-content: flex-end;
    }

    .custom-save-button {
        color: white;
        background-color: #1976d2;
    }

    .custom-radio .v-input--selection-controls__input {
        display: none; /* Hide the default radio button */
    }

    .custom-radio .v-icon {
        font-size: 24px; /* Adjust the icon size */
        color: #ccc; /* Default icon color */
        transition: color 0.3s;
    }

    /* Apply different colors based on index */
    .custom-radio:nth-child(1) .v-icon {
        color: #FF5733;
    }

    .custom-radio:nth-child(2) .v-icon {
        color: #3A89F1;
    }

    .custom-radio:nth-child(3) .v-icon {
        color: #9C27B0;
    }

    .custom-textarea .v-input__control {
        border-color: #bdbdbd;
    }

    .custom-textarea .v-label {
        color: #757575;
        font-weight: 500;
        font-size: 14px;
    }

    .custom-textarea .v-input__icon--clear {
        color: #bdbdbd;
    }

    .custom-textarea textarea {
        font-size: 14px;
        color: #333;
        border: none;
        resize: vertical;
    }

        .custom-textarea textarea:focus {
            box-shadow: 0 0 0 2px #1976d2;
        }
</style>
